import React, { Suspense } from 'react';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { LoadingSpinner } from './components/ui/LoadingSpinner';
import { ConfigProvider } from './context/ConfigContext';

const Dashboard = React.lazy(() => import('./pages/Dashboard'));
const ResidentialMarketIndicatorsPage = React.lazy(() => import('./pages/ResidentialMarketIndicatorsPage'));
const DataManagement = import.meta.env.DEV
  ? React.lazy(() => import('./pages/DataManagement'))
  : (() => null);

function DashboardByIdRoute() {
  const { id } = useParams();
  return (
    <ConfigProvider dashboardId={id}>
      <Dashboard />
    </ConfigProvider>
  );
}

export default function App() {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Routes>
        <Route
          path="/"
          element={
            <ConfigProvider>
              <Dashboard />
            </ConfigProvider>
          }
        />
        <Route
          path="/residential-market-indicators"
          element={
            <ConfigProvider>
              <ResidentialMarketIndicatorsPage />
            </ConfigProvider>
          }
        />
        {/* Development-only dashboard management */}
        {import.meta.env.DEV && (
          <Route
            path="/manage-data"
            element={
              <ConfigProvider>
                <DataManagement />
              </ConfigProvider>
            }
          />
        )}
        {import.meta.env.DEV && <Route path="/dashboard/:id" element={<DashboardByIdRoute />} />}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}
